import { Grid, Stack, Typography } from "@mui/material";
import TextFieldInput from "components/input/textField";
import { ActivityBiomassScreening } from "types/firestoreFeatures";
import { useTranslation } from "utils/locales/utilityFunctions";
import { BIOMASS_CATEGORIES } from "../options";

type BiomassScreeningCertificateFieldsProps = {
  data: ActivityBiomassScreening;
  setData: (change: { value: any; key: string }) => void;
  disabled: boolean;
  hasError?: boolean;
};

export const hasBiomassScreeningCertificateFields = (
  data: ActivityBiomassScreening,
): data is NonNullable<ActivityBiomassScreening> =>
  !!data &&
  [BIOMASS_CATEGORIES[1], BIOMASS_CATEGORIES[2]].includes(data.category) &&
  data.riscAssessment?.includes("certified") === true;

export const hasBiomassScreeningCertificationNumber = (
  data: ActivityBiomassScreening,
) =>
  !!data &&
  [data.fscCertificationNumber, data.pefcCertificationNumber, data.certificationNumber].some(
    (number) => number?.trim(),
  );

const BiomassScreeningCertificateFields = ({
  data,
  setData,
  disabled,
  hasError = false,
}: BiomassScreeningCertificateFieldsProps) => {
  const { translate } = useTranslation();
  if (!hasBiomassScreeningCertificateFields(data)) return null;

  return (
    <Grid item xs={12} sm={3}>
      <Typography color="secondary" sx={{ mb: 1 }}>
        {translate("biomass-project-form-certificate-number")}
      </Typography>
      <Stack spacing={1}>
        <TextFieldInput title={translate("biomass-project-form-fsc-certificate-number")} value={data.fscCertificationNumber || ""} showLabel={true} fullWidth={true} handleChange={(event) => setData({ value: event.target.value, key: "fscCertificationNumber" })} required={false} disabled={disabled} error={hasError} />
        <TextFieldInput title={translate("biomass-project-form-pefc-certificate-number")} value={data.pefcCertificationNumber || ""} showLabel={true} fullWidth={true} handleChange={(event) => setData({ value: event.target.value, key: "pefcCertificationNumber" })} required={false} disabled={disabled} error={hasError} />
      </Stack>
      {data.certificationNumber && <Typography variant="caption" color="text.secondary">{`${translate("biomass-project-form-legacy-certificate-number")}: ${data.certificationNumber}`}</Typography>}
    </Grid>
  );
};

export default BiomassScreeningCertificateFields;
